<template>
  <span class="text-xl font-semibold leading-none text-highlight">
    <slot />
  </span>
</template>
